import { Button } from "primereact/button";
import XmotTask from "./XmotTask";
import XmotQuestion from "./XmotQuestion";
import { Divider } from "primereact/divider";
import ShowTQItemHeading from "./xmotTQSharedComponents/ShowTQItemHeading";

const XmotRandomizationBlock = ({
  isLocked,
  addTQInRandomBlock,
  taskQuestion,
  taskQuestions,
  index,
  handleCheckboxSelection,
  cloneSingleTaskQuestionAt,
  showLogicDialog,
  showConfirm,
  surveyType,
  setTaskquestion,
  handleImageUpload,
  handleVideoUpload,
  updateQuestionItem,
  updateTaskQuestionItem,
  handleAddQuesTask,
  handleShuffle,
  onDeleteSkipLogic,
  deleteTQLoading,
  taskQuesRefs,
}) => {
  const { blockTaskQues = [] } = taskQuestion;

  return (
    <div className="randomization-block p-3 mb-4">
      {blockTaskQues?.length ? (
        <div className="tasks-questions-section">
          {blockTaskQues.map((blockQuestion, idx) => {
            const taskSubQuestionIndex = index + idx;
            return (
              <div
                key={idx}
                className={`mt-2 ${blockQuestion?.isExtraction ? "px-2" : ""}`}
                ref={(el) => (taskQuesRefs.current[taskSubQuestionIndex] = el)}
                style={{
                  backgroundColor: blockQuestion?.isExtraction ? "#f9f9ed" : "",
                }}
              >
                <ShowTQItemHeading
                  taskQues={blockQuestion}
                  index={index}
                  handleCheckboxSelection={handleCheckboxSelection}
                  isLocked={isLocked}
                  cloneSingleTaskQuestionAt={cloneSingleTaskQuestionAt}
                  showLogicDialog={showLogicDialog}
                  showConfirm={showConfirm}
                  taskQuestion={taskQuestions}
                  isRandomizeBlock={true}
                  subIndex={idx}
                />

                {blockQuestion.type === "task" ? (
                  <XmotTask
                    taskQuestion={blockQuestion}
                    taskQuestions={taskQuestions}
                    index={taskSubQuestionIndex}
                    updateTaskItem={(updateType, value) => {
                      updateTaskQuestionItem(
                        taskSubQuestionIndex,
                        updateType,
                        value,
                        null,
                      );
                    }}
                    updateTaskItemWithChildIndex={(
                      updateType,
                      value,
                      childIndex,
                    ) =>
                      updateTaskQuestionItem(
                        taskSubQuestionIndex,
                        updateType,
                        value,
                        childIndex,
                      )
                    }
                    handleAddQuesTask={(itemType) =>
                      handleAddQuesTask(itemType, taskSubQuestionIndex, true)
                    }
                    handleImageUpload={() =>
                      handleImageUpload(taskSubQuestionIndex, "photo")
                    }
                    handleVideoUpload={() =>
                      handleVideoUpload(taskSubQuestionIndex)
                    }
                    handleVideoThumbUpload={() =>
                      handleImageUpload(taskSubQuestionIndex, "videoThumb")
                    }
                    deleteSubTQ={showConfirm}
                    setTaskquestion={setTaskquestion}
                    handleShuffle={handleShuffle}
                    isLocked={isLocked}
                    surveyType={surveyType}
                    onDeleteSkipLogic={onDeleteSkipLogic}
                    deleteSlLoading={deleteTQLoading}
                  />
                ) : (
                  ""
                )}
                {blockQuestion.type === "question" ? (
                  <XmotQuestion
                    taskQuestion={blockQuestion}
                    taskQuestions={taskQuestions}
                    index={taskSubQuestionIndex}
                    updateQuestionItem={(updateType, value) =>
                      updateTaskQuestionItem(
                        taskSubQuestionIndex,
                        updateType,
                        value,
                      )
                    }
                    handleAddQuesTask={(itemType) =>
                      handleAddQuesTask(itemType, taskSubQuestionIndex, true)
                    }
                    answerOptionText={`${taskSubQuestionIndex + 1}`}
                    handleShuffle={handleShuffle}
                    isLocked={isLocked}
                    surveyType={surveyType}
                  />
                ) : (
                  ""
                )}
                <Divider />
              </div>
            );
          })}
        </div>
      ) : (
        ""
      )}
      <div className="d-flex justify-content-center align-items-center my-4">
        <Button
          className="add-task-btn me-1 createClientBtn tq-btn py-1"
          aria-label="Add task"
          onClick={() => addTQInRandomBlock("task")}
          disabled={isLocked}
        >
          Add task
        </Button>
        <Button
          className="add-question-btn ms-2 createClientBtn tq-btn py-1"
          aria-label="Add question"
          onClick={() => addTQInRandomBlock("question")}
          disabled={isLocked}
        >
          Add question
        </Button>
      </div>
    </div>
  );
};

export default XmotRandomizationBlock;
